import { keyParts } from './keys';

/**
 * A shortcut drawn as keycaps: each key in its own small flat cap, a little apart, so
 * "Ctrl Shift E" never runs together into one string. Mohamad's pick 1 of five
 * (2026-10-06, https://claude.ai/artifact/5xz2A9Dm7t31p6K6nV7aw1). Said the way this
 * computer's keyboard says it (`keyParts`). What is not a shortcut — a menu's size column,
 * "210 × 297 mm" — is left as words.
 */
export function KeyCaps({ shortcut, lit = false, className = '' }: { shortcut: string; /** On a highlighted (accent) menu row. */ lit?: boolean; className?: string }) {
  const parts = keyParts(shortcut);
  if (!parts) return <span className={`tnum ${className || 'text-label-2'}`}>{shortcut}</span>;
  return (
    <span className={`inline-flex shrink-0 items-center gap-[3px] ${className}`} aria-label={parts.join(' ')}>
      {parts.map((part, index) => (
        <kbd
          key={index}
          className={`inline-grid h-[18px] min-w-[18px] place-items-center rounded-[5px] px-[5px] font-sans text-[10.5px] font-medium leading-none ${
            lit ? 'bg-white/20 text-on-accent' : 'bg-fill-1 text-label-2 shadow-[inset_0_0_0_1px_var(--separator)]'
          }`}
        >
          {part}
        </kbd>
      ))}
    </span>
  );
}
